<template>
    <div class="is-grow-1 mt-4 vertical-flow">
        <empty-table-message 
            v-if="usuarios && !usuarios.length"
            :msg="firstTime ? 'msg-relatorio-rota-first-time-data' : 'msg-no-results'"
        />
        <b-table
            v-else
            class="data-table px-0"
            :data="usuarios"
            detail-key="idusuario"
            height="calc(100vh - 225px)"
            detailed show-detail-icon sticky-header
        >
                <b-table-column 
                    v-for="(f, i) in fields"
                    class="td-center"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.label) : ''"
                    :width="f.width"
                    :sortable="f.sortable"
                    :centered="f.centered"
                    v-slot="props"
                >
                    <div v-if="f.key == 'usuario'">
                        {{ props.row.nome }}
                    </div>
                    <div v-else-if="f.key == 'p-pedido'">
                        {{ Math.round((props.row.qtd_pedidos / props.row.planejados) * 100) }} %
                    </div>
                    <div v-else-if="f.key == 'p-naovenda'">
                        {{ Math.round((props.row.qtd_naovendas / props.row.planejados) * 100) }} %
                    </div>
                    <div v-else-if="f.key == 'p-atendido'">
                        {{ Math.round((props.row.realizados / props.row.planejados) * 100) }} %
                    </div>
                    <div v-else-if="f.key == 'p-naoatendido'">
                        {{ Math.round(((props.row.planejados - props.row.realizados) / props.row.planejados) * 100) }} %
                    </div>
                </b-table-column>

            <template slot="detail" slot-scope="props">
                <b-table
                    class="data-table px-0"
                    :data="props.row.rota"
                    :row-class="(row, index) => row.id === selectedRow ? 'is-selected' : ''"
                >
                        <b-table-column 
                            v-for="(f, i) in fieldsInnerTable"
                            class="td-center"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'distancia' ? $t(f.label) : $t(f.label, { distancia: parametrizacao })"
                            :width="f.width"
                            :sortable="f.sortable"
                            :centered="f.centered"
                            :visible="f.visible"
                            v-slot="propsrota"
                        >
                            <div v-if="f.key == 'cliente'">
                                {{ propsrota.row.cliente.rsocial }}
                            </div>
                            <div v-else-if="f.key == 'acoes'">
                                <span v-if="propsrota.row.pedidos && propsrota.row.pedidos.length > 0">{{ $t('pedido') }}<br></span>
                                <span v-if="propsrota.row.naovendas && propsrota.row.naovendas.length > 0">{{ $t('nao-venda') }}<br></span>
                                <span v-if="propsrota.row.tomadaspreco && propsrota.row.tomadaspreco.length > 0">{{ $t('tomada-preco') }}<br></span>
                                <span v-if="propsrota.row.atendimentos && propsrota.row.atendimentos.length > 0">{{ $t('atendimento') }}<br></span>
                            </div>
                            <div v-else-if="f.key == 'status'">
                                <span v-if="propsrota.row.clienteAvulso">
                                    {{ $t('avulso') }}
                                </span>
                                <span v-else-if="
                                    (propsrota.row.pedidos && propsrota.row.pedidos.length > 0) || 
                                    (propsrota.row.naovendas && propsrota.row.naovendas.length > 0) ||
                                    (propsrota.row.tomadaspreco && propsrota.row.tomadaspreco.length > 0) || 
                                    (propsrota.row.atendimentos && propsrota.row.atendimentos.length > 0)
                                ">
                                    {{ $t('atendido') }}
                                </span>
                                <span v-else>
                                    {{ $t('nao-atendido') }}
                                </span>
                            </div>
                            <div v-else-if="f.key == 'checks'">
                                <div class="is-flex is-flex-centered" v-for="c in propsrota.row.checks" :key="c.uuid">
                                    <span class="is-100 checktime">{{ c.checkindatahora | moment("L LT") }}</span>
                                    <b-icon icon="chevron-right" type="is-dark"/>
                                    <span class="is-100 checktime">{{ c.checkoutdatahora | moment("L LT") }}</span>
                                </div>
                            </div>
                            <div v-else-if="f.key == 'permanencia'">
                                <div v-for="c in propsrota.row.checks" :key="c.uuid">
                                    <span v-if="c.duracao">
                                        {{ $moment.utc(c.duracao * 1000).format('HH:mm:ss') }}
                                    </span>
                                    <span v-else>
                                        –
                                    </span>
                                </div>
                            </div>
                            <div v-else-if="f.key == 'distancia'">
                                <div v-for="(c, i) in propsrota.row.checks" :key="`${c.uuid}${i}`">
                                    <span v-if="c.distanciaCheckInCliente"
                                        :class="{
                                            'is-text-color-success': isCheckInDistanceLowerThenAllowed(c.distanciaCheckInCliente),
                                            'is-text-color-danger': !isCheckInDistanceLowerThenAllowed(c.distanciaCheckInCliente)
                                        }"
                                    >
                                        {{ Math.floor(c.distanciaCheckInCliente) }}
                                    </span>
                                    <b-icon
                                        v-else
                                        icon="dots-horizontal"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t(c.mensagemCalculoDistancia)"
                                    />
                                </div>
                            </div>
                        </b-table-column>
                </b-table>
            </template>
        </b-table>
    </div>
</template>

<script>
import ParametrizacaoService from "@/services/ParametrizacaoService";

    export default {
        props: {
            rotas: {
                type: Array,
                default: () => []
            },
            selectedRow: {
                type: Number,
                default: 0
            },
            firstTime: {
                type: Boolean,
                default: false
            }
        },
        created() {
            this.carregaParametrizacaoTrabalhaCheckInOut();

            this.carregaParametrizacaoCheckInDistancia();
        },
        data() {
            return {
                serviceParametrizacao: new ParametrizacaoService(this.$http, this.$router),
                parametrizacao: 0,
                fields: [
                    {key: 'usuario',        label: 'colaborador'},
                    {key: 'p-naovenda',     label: 'porc-naovenda',     centered: true, width: "150px"},
                    {key: 'p-pedido',       label: 'porc-pedido',       centered: true, width: "150px"},
                    {key: 'p-atendido',     label: 'porc-atendido',     centered: true, width: "150px"},
                    {key: 'p-naoatendido',  label: 'porc-nao-atendido', centered: true, width: "155px"},
                ],
                fieldsInnerTable: [
                    {key: 'cliente',        label: 'cliente',           width: '30%'},
                    {key: 'acoes',          label: 'acoes',             width: '10%'},
                    {key: 'status',         label: 'status',            centered: true, width: '15%'},
                    {key: 'checks',         label: 'horario',           centered: true, width: '25%'},
                    {key: 'permanencia',    label: 'permanencia',       width: '10%'},
                    {key: 'distancia',    label: 'distancia-n',       width: '10%', centered: true}
                ]
            }
        },
        computed: {
            /*  A ideia aqui é transformar o array de ROTAVISITAHISTORICO
                em um array de USUARIOS, então no final a saída será as
                rotas agrupadas por usuário. */
            usuarios() {
                let users = {};

                this.rotas.forEach(r => {
                    let key = r.usuario.idusuario;

                    let rota = r;        
            
                    if (!users[key]) {
                        users[key] = r.usuario;
                        users[key].planejados = 0;
                        users[key].realizados = 0;
                        users[key].qtd_naovendas = 0;
                        users[key].qtd_pedidos = 0;
                        users[key].rota = [];
                    }

                    users[key].rota.push(r);

                    if (!r.clienteAvulso) {
                        users[key].planejados++;

                        let atends = r.atendimentos.length;
                        let nvenda = r.naovendas.length;
                        let pedido = r.pedidos.length;
                        let tpreco = r.tomadaspreco.length;

                        if (atends || nvenda || pedido || tpreco) {
                            users[key].realizados++;

                            if (nvenda) users[key].qtd_naovendas++;
                            if (pedido) users[key].qtd_pedidos++;
                        }
                    }

                });

                /* Que isso faz: Transforma o objeto em um array. */
                return Array.from(Object.keys(users), c => users[c]);
            },
        },
        methods: {
            carregaParametrizacaoCheckInDistancia() {
                this.serviceParametrizacao
                    .getConfigByNomeIdusuario('CHECKINDISTANCIA', this.$store.state.user.id)
                    .then(({ content }) => {
                        this.parametrizacao = content.valor;
                    }).catch(e => {
                        console.warn('[ROTA] Parametrização de distância do checkin não está habilitada.');
                    });
            },
            carregaParametrizacaoTrabalhaCheckInOut() {
                this.serviceParametrizacao
                    .getConfigByNomeIdusuario('TRABALHACHECKINOUT', this.$store.state.user.id)
                    .then(({ content }) => {
                        this.fieldsInnerTable.find(field => field.key === "distancia").visible = content.valor === "S";
                    }).catch(e => {
                        console.warn('[ROTA] Parametrização de distância do checkin não está habilitada.');
                    });
            },
            isCheckInDistanceLowerThenAllowed(distanciaCheckInCliente) {
                return distanciaCheckInCliente && Math.floor(distanciaCheckInCliente) <= Number(this.parametrizacao);
            },
        }
    }
</script>

<style lang="scss" scoped>
.checktime {
    max-width: 300px;
}
</style>